document.documentElement.classList.remove("no-js");

(function () {
  var toggle = document.getElementById("navToggle");
  if (!toggle) return;

  toggle.addEventListener("click", function () {
    var open = document.body.classList.toggle("menu-open");
    toggle.setAttribute("aria-expanded", String(open));
  });

  document.querySelectorAll(".mobile-menu a").forEach(function (link) {
    link.addEventListener("click", function () {
      document.body.classList.remove("menu-open");
      toggle.setAttribute("aria-expanded", "false");
    });
  });
})();

(function () {
  var mainImg = document.getElementById("ProductMainImageImg");
  if (!mainImg) return;

  var variantImages = {};
  var mapEl = document.getElementById("ProductVariantImages");
  if (mapEl) {
    try {
      variantImages = JSON.parse(mapEl.textContent);
    } catch {
      variantImages = {};
    }
  }

  function setMainImage(src, alt) {
    if (!src) return;
    mainImg.src = src;
    if (alt) mainImg.alt = alt;
    document.querySelectorAll(".product-thumb").forEach(function (btn) {
      btn.classList.toggle("active", btn.getAttribute("data-image-src") === src);
    });
  }

  document.querySelectorAll(".product-thumb").forEach(function (btn) {
    btn.addEventListener("click", function () {
      setMainImage(btn.getAttribute("data-image-src"), btn.getAttribute("data-image-alt"));
    });
  });

  var select = document.getElementById("ProductVariant");
  if (select) {
    select.addEventListener("change", function () {
      var src = variantImages[select.value];
      if (src) setMainImage(src);
    });
  }
})();
